 angular
 .module('vppApp')
 .directive('mobileNavStateDirective', mobileNavStateDirective);

 function mobileNavStateDirective() {
	 return {
		 link: function (scope, element, attr) {
			 scope.$watch(attr.mobileNavStateDirective, function (newVal) {
				 console.log("mobileNavStateDirective");
				 if (newVal)
				 {
					 element.addClass('show shadow');
					 return;
				 }
				 element.removeClass('show shadow');
			 });
		 }
	 };
 }
